import { Constants } from '@constants';
import { IconExclamationTriangleFilled } from '@iwoca/icons';
import { Text, Tooltip } from '@iwoca/orion';
import { FormattedMessage, useIntl } from 'react-intl';

import { useGetDeliveryAddressData } from './useGetDeliveryAddressData';

export const ResidentialAddress = () => {
    const intl = useIntl();
    const { residential_address } = useGetDeliveryAddressData();

    if (!residential_address) {
        return (
            <>
                <Text className="mb-m mt-xl flex flex-row gap-l text-m font-bold">
                    <IconExclamationTriangleFilled
                        className="my-auto fill-error"
                        fontSize={20}
                    />
                    <FormattedMessage
                        defaultMessage="Unverified address"
                        id="_.credit_card.replace_card.address.error"
                    />
                </Text>
                <Text className="text-m font-reg">
                    <FormattedMessage
                        defaultMessage="We're unable to verify your residential address. Please call us on <a>{phone}</a>"
                        id="_.credit_card.replace_card.address.error.description"
                        values={{
                            phone: Constants.CREDIT_CARD_PHONE_NUMBER.display,
                            a: (chunks) => (
                                <a
                                    href={`tel:${Constants.CREDIT_CARD_PHONE_NUMBER.tel}`}
                                >
                                    <strong>{chunks}</strong>
                                </a>
                            )
                        }}
                    />
                </Text>
            </>
        );
    }

    return (
        <>
            <div className="my-xl flex flex-col rounded-xs border border-secondary-80 bg-primary-97 p-m">
                <div className="mb-s flex items-center gap-s">
                    <Text className="text-l font-bold">
                        <FormattedMessage
                            defaultMessage="ID verified address"
                            id="_.credit_card.replace_card.address_title"
                        />
                    </Text>
                    <Tooltip
                        variant="secondary"
                        content={intl.formatMessage(
                            {
                                defaultMessage:
                                    'If you need this card to be mailed to a different address, please call us on {phone}',
                                id: '_.credit_card.replace_card.address_change.description'
                            },
                            {
                                phone: Constants.CREDIT_CARD_PHONE_NUMBER
                                    .display
                            }
                        )}
                    />
                </div>
                <Text className="text-m font-reg">
                    {residential_address?.house_number}
                    {residential_address?.house_number &&
                        residential_address?.street_line_1 &&
                        /* eslint-disable-next-line formatjs/no-literal-string-in-jsx */
                        ' '}
                    {residential_address?.street_line_1}
                    {residential_address?.street_line_1 &&
                        residential_address?.town &&
                        /* eslint-disable-next-line formatjs/no-literal-string-in-jsx */
                        ', '}
                    {residential_address?.town}
                </Text>
                <Text className="text-m font-reg">
                    {residential_address?.postcode}
                </Text>
            </div>
        </>
    );
};
